import React from 'react';
import { Box, KeyValue, TextFieldForm, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Radio } from '@mui/material';

import ToggleDisplayEditFormItem from '../../../../../components/ToggleDisplayEditFormItem';
import { useStyles } from '../styles';
import HideOrShow from './HideOrShow';
import { getAddressDisplayArray } from '../../../../../utils/ComponentUtils';
import { AddressProps } from './ResidentialAddress';

const ForeignAddress = ({
  isEditState,
  formHook,
  isDisableInputs = undefined,
  formDefaultValues = undefined,
  formControlLabel,
  sameRowAddress = false,
}: AddressProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  if (!isEditState) {
    return (
      <Box className={`${sameRowAddress && classes.halfWidthRightItem}`}>
        <KeyValue
          keyText={t('profile->>CreateCandidateForm.Foreign Address')}
          keyIsPrefferedText={
            formDefaultValues?.preferredAddress === 'F' ? 'Preferred Address' : undefined
          }
          id="value-foreignAddress"
          valueText={getAddressDisplayArray([
            formDefaultValues?.foreignAddress1,
            formDefaultValues?.foreignAddress2,
            formDefaultValues?.foreignAddress3,
          ])}
        />
      </Box>
    );
  }

  return (
    <Box className={`${classes.responsiveFlexContainer} ${classes.formElementContainer}`}>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        id="inputText-foreignAddress1"
        isHideDisplay
        containerClassName={classes.groupFormElementContainer}
        EditComponent={
          <TextFieldForm
            form={formHook}
            isInputTextUpperCase
            onChange={(e) => formHook?.setValue('foreignAddress1', e.target.value.toUpperCase())}
            placeholder={t('profile->>CreateCandidateForm.Foreign Address 1')}
            defaultValue={formDefaultValues?.foreignAddress1}
            label={t('profile->>CreateCandidateForm.Foreign Address')}
            id="inputText-foreignAddress1"
            name="foreignAddress1"
            type="text"
            error={!!formHook?.formState.errors.foreignAddress1}
            helperText={formHook?.formState.errors?.foreignAddress1?.message?.toString()}
            fullWidth
            inputProps={{ readOnly: isDisableInputs?.foreignAddress1 }}
            isSubLabelBelowLabel
            subLabel={
              <Typography variant="body2">{t('profile->>AddressHelper.ForeignAddress')}</Typography>
            }
          />
        }
      />

      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        isHideDisplay
        containerClassName={classes.groupFormElementContainer}
        id="inputText-foreignAddress2"
        EditComponent={
          <TextFieldForm
              form={formHook}
            isInputTextUpperCase
            onChange={(e) => formHook?.setValue('foreignAddress2', e.target.value.toUpperCase())}
            placeholder={t('profile->>CreateCandidateForm.Foreign Address 2')}
            defaultValue={formDefaultValues?.foreignAddress2}
            id="inputText-foreignAddress2"
            name="foreignAddress2"
            type="text"
            error={!!formHook?.formState.errors.foreignAddress2}
            helperText={formHook?.formState.errors?.foreignAddress2?.message?.toString()}
            fullWidth
            inputProps={{ readOnly: isDisableInputs?.foreignAddress2 }}
          />
        }
      />

      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        id="inputText-foreignAddress3"
        isHideDisplay
        containerClassName={classes.groupFormElementContainer}
        EditComponent={
          <TextFieldForm
              form={formHook}
            isInputTextUpperCase
            onChange={(e) => formHook?.setValue('foreignAddress3', e.target.value.toUpperCase())}
            placeholder={t('profile->>CreateCandidateForm.Foreign Address 3')}
            defaultValue={formDefaultValues?.foreignAddress3}
            name="foreignAddress3"
            id="inputText-foreignAddress3"
            type="text"
            error={!!formHook?.formState.errors.foreignAddress3}
            helperText={formHook?.formState.errors?.foreignAddress3?.message?.toString()}
            fullWidth
            inputProps={{ readOnly: isDisableInputs?.foreignAddress3 }}
          />
        }
      />

      <HideOrShow
        isHide={!isEditState}
        Component={
          <FormControlLabel
            value="F"
            name="preferredAddress"
            control={<Radio />}
            label={formControlLabel ?? 'Preferred Address'}
            disabled={isDisableInputs?.preferredAddress}
          />
        }
      />
    </Box>
  );
};

export default ForeignAddress;
